import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import { AiChangeType } from '../../../../../../../ai';
import { MatchingAddQuestionStrategy } from './matching-add.strategy';
import { MatchingDeleteQuestionStrategy } from './matching-delete.strategy';
import { MatchingUpdateQuestionStrategy } from './matching-update.strategy';
export var MatchingAiChangeStrategyFactory = /*#__PURE__*/function () {
  function MatchingAiChangeStrategyFactory() {
    _classCallCheck(this, MatchingAiChangeStrategyFactory);
  }

  _createClass(MatchingAiChangeStrategyFactory, null, [{
    key: "create",
    value: function create(context) {
      switch (context.changeType) {
        case AiChangeType.Add:
          return new MatchingAddQuestionStrategy(context);

        case AiChangeType.Update:
          return new MatchingUpdateQuestionStrategy(context);

        case AiChangeType.Delete:
          return new MatchingDeleteQuestionStrategy(context);

        default:
          throw new Error('Unsupported change type for matching');
      }
    }
  }]);

  return MatchingAiChangeStrategyFactory;
}();